"use strict";

exports.__esModule = true;
var isDevelopment = typeof process !== 'undefined' && process.env && (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');
exports["default"] = isDevelopment;